import { useMemo } from "react";

import { Col, Layout, Row, Typography } from "antd";
import {
  Navigate,
  Outlet,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { selectIsAuthenticated } from "@/redux/authentication/selectors.js";
import BaseButton from "@/components_v2/Button/BaseButton.js";

const { Title } = Typography;

const DefaultLayout = () => {
  const { Content, Footer } = Layout;
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const link = useMemo(() => {
    if (location.pathname === "/login") {
      return {
        title: t("links.loginPage"),
        to: "/register",
        buttonContent: t("buttons.register"),
      };
    }
    return {
      title: t("links.registerPage"),
      to: "/login",
      buttonContent: t("buttons.signIn"),
    };
  }, [location.pathname]);

  if (isAuthenticated) {
    if (location.pathname.includes("/public")) {
      return (
        <Navigate
          to={location.pathname.replace("/public", "") + location.search}
        />
      );
    }

    return (
      <Navigate
        to={
          searchParams.has("redirect_to") ? searchParams.get("redirect_to") : ""
        }
      />
    );
  }

  return (
    <Layout>
      <Row className="m-3" align="middle" justify="end">
        <Col className="me-3">
          <Title level={5}>{link.title}</Title>
        </Col>
        <Col>
          <BaseButton to={link.to}>{link.buttonContent}</BaseButton>
        </Col>
      </Row>
      <Content className="w-100">
        <Outlet />
      </Content>
      <Footer>
        <Row>
          <Col />
          <Col />
        </Row>
      </Footer>
    </Layout>
  );
};

export default DefaultLayout;
